import { selectPage, setTrafficId } from "@redux";
import { useEffect } from "react";
import { IoMdTime } from "react-icons/io";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router";

export const PageTrafficSource = () => {
    const { id } = useParams<{ id: string }>();
    const dispatch = useDispatch();
    const { isTrafficSourceExpired } = useSelector(selectPage);
    useEffect(() => {
        if (id) {
            // set traffice source to store, inorder to use that id on header call
            dispatch(setTrafficId(id));
        }
    }, [id]);

    // ponytail: inline styles, no theme tokens — this renders before the merchant theme is loaded
    if (isTrafficSourceExpired) {
        return (
            <div
                style={{
                    position: "fixed",
                    inset: 0,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: 12,
                    padding: 24,
                    background: "#fff",
                    zIndex: 9999,
                    textAlign: "center",
                    fontSize: 18,
                    color: "#333",
                }}
            >
                <IoMdTime size={56} color="#999" />
                Link has been expired.
            </div>
        );
    }
    return <></>;
};
